import { NodeSize } from '../model/bigdatapool/bigdatapool';

interface IComputeSize {
    executorCores: number;
    executorMemory: number;
    driverCores: number;
    driverMemory: number;
}

export const MEMORY_COMPUTE_SIZE_PRESETS: Readonly<Partial<Record<NodeSize, IComputeSize>>> = Object.freeze(
    {
        Small: {
            executorCores: 4,
            executorMemory: 28,
            driverCores: 4,
            driverMemory: 28
        },
        Medium: {
            executorCores: 8,
            executorMemory: 56,
            driverCores: 8,
            driverMemory: 56
        },
        Large: {
            executorCores: 16,
            executorMemory: 112,
            driverCores: 16,
            driverMemory: 112
        },
        XLarge: {
            executorCores: 32,
            executorMemory: 224,
            driverCores: 32,
            driverMemory: 224
        },
        XXLarge: {
            executorCores: 64,
            executorMemory: 400,
            driverCores: 64,
            driverMemory: 400
        }
    }
);
